import { defineMessages } from 'react-intl';
import { hrefFromURL } from '../hrefFromURL';
import { getAbsoluteUrl } from '../getAbsoluteUrl';
export const SearchTabs = {
    adresy: 'adresy',
    parcely: 'parcely',
    coords: 'coords',
};
export const defaultSearchMessages = defineMessages({
    adresy: {
        id: 'search.adresy',
        defaultMessage: 'adresy',
    },
    parcely: {
        id: 'search.parcely',
        defaultMessage: 'parcely',
    },
    coords: {
        id: 'search.coords',
        defaultMessage: 'souřadnice',
    },
});
export const DEFAULT_SEARCH_TABS = {
    adresy: {
        type: 'GeoCode',
        fieldName: 'text',
        id: 'adresy',
        minQueryLength: 1,
        url: 'https://services7.tmapserver.cz/arcgis/rest/services/Locators/cz_adr,cz_ul,cz_ob/GeocodeServer/findAddressCandidates?outFields=label,id,type,typeDescCz,typeDescEn,shpGeoJson&f=geojson&outSR=5514&',
        resultsLimit: 49,
        zoom: 22,
    },
    parcely: {
        type: 'GeoCode',
        fieldName: 'text',
        id: 'parcely',
        minQueryLength: 1,
        url: 'https://services7.tmapserver.cz/arcgis/rest/services/Locators/cz_ku,cz_par/GeocodeServer/findAddressCandidates?outFields=label,id,type,typeDescCz,shpGeoJson&f=geojson&outSR=5514&',
        resultsLimit: 49,
    },
    coords: {
        type: 'GeoCode',
        fieldName: 'text',
        id: 'coords',
        minQueryLength: 5,
        url: '//cz-services.tmapserver.cz/services/ftext/service.php?source=coord&outFields=shpJson,typeDesc,id,type,lat,lon,x5513,y5513&outSR=5514',
        resultsLimit: 49,
    },
};
const deriveTabStateFromConfig = (config) => {
    const absoluteUrl = getAbsoluteUrl(config.url);
    if (!absoluteUrl) {
        console.error('Search configuration is removed due to missing URL.', config);
        return null;
    }
    const url = hrefFromURL(absoluteUrl);
    let resultsLimit = config.resultsLimit || 50;
    if (resultsLimit > 250) {
        console.error(`The resultsLimit in '${config.id}' is greater than recommended.`);
        resultsLimit = Math.min(resultsLimit, 1000);
    }
    return { ...config, resultsLimit, url };
};
export const deriveMapSearchStateFromConfig = (config) => {
    const tabs = (config?.tabs?.map(deriveTabStateFromConfig).filter(Boolean) || []);
    if (config?.addDefaultTabs) {
        const params = {};
        if (config.regionCodes) {
            params.regionCodes = config.regionCodes;
        }
        tabs.unshift({ ...DEFAULT_SEARCH_TABS.coords });
        tabs.unshift({ ...DEFAULT_SEARCH_TABS.parcely, params });
        tabs.unshift({ ...DEFAULT_SEARCH_TABS.adresy, params });
    }
    const activeTab = tabs[0];
    if (activeTab) {
        return { tabs, activeTabId: activeTab.id };
    }
};
//# sourceMappingURL=deriveMapSearchStateFromConfig.js.map